/* tslint:disable */
/* eslint-disable */
/**
 * Workflow service API
 * Service for workflow management
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { A } from './A';
import {
    AFromJSON,
    AFromJSONTyped,
    AToJSON,
} from './A';

/**
 * 
 * @export
 * @interface Creder
 */
export interface Creder {
    /**
     * 
     * @type {string}
     * @memberof Creder
     */
    v?: string;
    /**
     * 
     * @type {string}
     * @memberof Creder
     */
    d?: string;
    /**
     * 
     * @type {string}
     * @memberof Creder
     */
    i?: string;
    /**
     * 
     * @type {string}
     * @memberof Creder
     */
    ri?: string;
    /**
     * 
     * @type {string}
     * @memberof Creder
     */
    s?: string;
    /**
     * 
     * @type {A}
     * @memberof Creder
     */
    a?: A;
    /**
     * 
     * @type {object}
     * @memberof Creder
     */
    r?: object;
}

/**
 * Check if a given object implements the Creder interface.
 */
export function instanceOfCreder(value: object): boolean {
    return true;
}

export function CrederFromJSON(json: any): Creder {
    return CrederFromJSONTyped(json, false);
}

export function CrederFromJSONTyped(json: any, ignoreDiscriminator: boolean): Creder {
    if (json == null) {
        return json;
    }
    return {
        
        'v': json['v'] == null ? undefined : json['v'],
        'd': json['d'] == null ? undefined : json['d'],
        'i': json['i'] == null ? undefined : json['i'],
        'ri': json['ri'] == null ? undefined : json['ri'],
        's': json['s'] == null ? undefined : json['s'],
        'a': json['a'] == null ? undefined : AFromJSON(json['a']),
        'r': json['r'] == null ? undefined : json['r'],
    };
}

export function CrederToJSON(value?: Creder | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'v': value['v'],
        'd': value['d'],
        'i': value['i'],
        'ri': value['ri'],
        's': value['s'],
        'a': AToJSON(value['a']),
        'r': value['r'],
    };
}

